<template>
    <div class="contanner base_page">
        <div class="banner_top" v-if="topImg">
            <img :src="topImg" alt="" />
        </div>
        <slot name="mooc"></slot>
        <div v-loading="loading">
            <div class="base_page_tab">
                <div class="tab_l">
                    <div
                        class="tab_item"
                        :class="tabActive === i ? 'tab_active' : ''"
                        v-for="(item, i) in tabs"
                        :key="item.name"
                        @click="changeTab(item, i)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div class="tab_r" v-if="showSort">
                    <img :src="currentImg" />
                </div>
            </div>
            <!-- 列表 -->
            <div class="list_warp" v-if="list.length">
                <template v-for="item in list">
                    <slot :item="item"></slot>
                </template>
            </div>
            <div v-else class="empty_box">
                <img src="~@/assets/empty.png" alt="">
            </div>
            <Pagination
                :total="total"
                :page.sync="currentPage"
                :limit.sync="pageSize"
                @pagination="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
import tabImg1 from '@/assets/tab_1.png'
import tabImg2 from '@/assets/tab_2.png'
import Pagination from '../Pagination'
import { post } from '@u/request'
import { getActivityStatus } from '@u/index'

const imgs = [tabImg1, tabImg2]

export default {

    name: '',
    props: {
        showSort: {
            type: Boolean,
            defalut: true
        }
    },
    components: {
        Pagination
    },
    data () {
        return {
            imgActive: 0,
            topImg: '',
            tabActive: 0,
            total: 0,
            currentPage: 1,
            pageSize: 12,
            list: [],
            tabs: [],
            loading: false,
            menuid: null, // 二级菜单id
            menuType: null, // 一级菜单type
        }
    },
    watch: {
        '$route'(route, Oroute){
            // 同模块不同id时重新请求
     
            // if ((route.name == Oroute.name) && (route.query.id != Oroute.query.id)) {
            //     if (route.query.id) {
            //          this.loadImage()
            //     }
               
            // }
         
        }
    },
   
    computed: {
        currentImg () {
            return imgs[this.imgActive]
        },
        pid() {
            return this.$route.query.id
        }
    },
    methods: {
        changeTab (item, i) {
            this.tabActive = i;
            this.menuid = item.id;
            this.loadList()
        },
        handleCurrentChange () {
            this.loadList()
        },

        async loadImage (pid) {
            // 获取顶部图片
            this.loading = true;
            const { data } = await post(`resource/showmenu/get/${pid}`);
            this.loading = false;
            this.topImg = data.bgimageThumbnail || data.bgimage;
            this.menuType = data.type;
            this.tabActive = 0;
            this.menuid = '';
            this.load();

        },
        async load () {
            // 获取tabs列表
            const params = {
                menutype: this.menuType,
                pid: this.pid,
                venueIds: this.$store.getters.venueId,
                status: '1'
            }
            const { data } = await post('resource/showapi/typelist', params);
            if (data.length) {
                this.tabs = [{ name: '全部', id: null }, ...data];
            }
            this.loadList()
        },
        async loadList () {
            // 获取内容列表
            this.loading = true;
            const params = {
                pid: this.pid,
                menutype: this.menuType,
                menuid: this.menuid,
                venueIds: this.$store.getters.venueId,
                page: this.currentPage,
                limit: this.pageSize
            }
            const { data, count } = await post('resource/showapi/list', params).catch(() => this.loading = false);
            this.loading = false;
            this.list = data.map(item => {
                if (item.venueLogo && item.venueLogo.indexOf('/images') === 0) {
                    item.venueLogo = VUE_APP_URL + (item.venueLogo.substr(1))
                }
                if (this.menuType == 2) {
                    const status = getActivityStatus(item.endTime);
                    item.activityStatus = status;
                    item.statusName = status ? '报名中' : '已结束'
                }
                item.startTime = this.mftDate(item.startTime);
                item.endTime = this.mftDate(item.endTime);
                return item
            });
            this.total = count;
        },
        mftDate (date) {
            let str = ''
            try {
                str = date.split(' ')[0]
            } catch (error) {

            }
            return str
        }
    },
    mounted () {
        this.loadImage(this.pid);
       
    }
}
</script>

<style scoped lang="scss">
.base_page {
    min-height: calc(100vh - 315px);
    padding: 20px 0;
    .banner_top {
        height: 320px;
        border-radius: 10px;
        margin-bottom: 20px;
        overflow: hidden;
        > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .base_page_tab {
        display: flex;
        align-items: center;
        margin: 25px 0 35px;
        .tab_l {
            display: flex;
            flex-wrap: wrap;
        }
        .tab_r {
            margin-left: auto;
        }
        .tab_item {
            padding: 0 20px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            color: #000;
        }
        .tab_active {
            color: #fff;
            background: #b30202;
        }
    }
    .list_warp {
        display: flex;
        flex-wrap: wrap;
    }
    .empty_box {
        text-align: center;
        margin: 50px;
    }
}
</style>